/* eslint-disable */
import React, { useEffect } from "react";
import LeadSubscribeConfirmBody from "components/LeadSubscribeConfirmBody/LeadSubscribeConfirmBody";

const LeadSubscribeConfirm = () => {
  useEffect(() => {
    document.title = "Subscription Confirmation";
  }, []);

  return (
    <main id="app">
      <LeadSubscribeConfirmBody />
    </main>
  );
};

export default LeadSubscribeConfirm;
